import { ProcessCard } from '@qpr/sipoc/components/Process';

export interface CanvasCellState {
  id: string;
  name: string;
  rows: CellRowState[];
}

export interface Process {
  id?: string;
  title: string;
}

export interface CellRowState {
  id: string;
  name: string;
  rangecolor: string;
  groupId?: string;
  measureId?: string;
}

const initialState: CanvasCellState[] = [
  { id: '1', name: 'Supplier', rows: [] as CellRowState[] },
  { id: '2', name: 'Input', rows: [] as CellRowState[] },
  { id: '3', name: 'Process', rows: [] as CellRowState[] },
  { id: '4', name: 'Output', rows: [] as CellRowState[] },
  { id: '5', name: 'Customer', rows: [] as CellRowState[] }
];

export const initialProcessesState: ProcessCard[] = [
  {
    id: 'p1',
    sipocid: 'p1',
    active: false,
    title: 'Process1',
    url: '..skeleton1'
  },
  {
    id: 'p2',
    sipocid: 'p2',
    active: false,
    title: 'Process2',
    url: '..skeleton2'
  },
  {
    id: 'p3',
    sipocid: 'p3',
    active: false,
    title: 'Process3',
    url: '..skeleton3'
  },
  {
    id: 'p4',
    sipocid: 'p4',
    active: false,
    title: 'Process4',
    url: '..skeleton4'
  },
  {
    id: 'p5',
    sipocid: 'p5',
    active: false,
    title: 'Process5',
    url: '..skeleton5'
  }
];

export const initialUpperState = {
  data: initialProcessesState,
  inited: false,
  error: { message: '', details: '' }
};

export const initialLowerState = {
  data: initialState,
  header: '',
  inited: false,
  error: { message: '', details: '' }
};
